import styled from "styled-components";
export const Container = styled.div `
  all: unset;
  justify-content: center;
  align-items: center;

  display: ${({ show }) => (show ? "flex" : "none")};

  @media ${({ theme }) => theme.device.xsmall} {
    height: 2rem;
  }

  @media ${({ theme }) => theme.device.medium} {
    height: 3rem;
  }

  input[type="range"].slider {
    all: unset;
    width: 100%;
    margin: 3px 0;
    background-color: transparent;
    -webkit-appearance: none;
  }
  input[type="range"].slider:focus {
    outline: none;
  }
  input[type="range"].slider::-webkit-slider-runnable-track {
    background: rgba(0, 0, 0, 0.12);
    border: 0;
    width: 100%;
    height: 0px;
    cursor: pointer;
  }
  input[type="range"].slider::-webkit-slider-thumb {
    margin-top: -3px;
    min-width: 6px;
    ${({ width }) => `width: ${width}%;`}
    height: 6px;
    background: ${({ theme, dark }) => dark ? theme.colors.white : theme.colors.black};
    border: 0;
    border-radius: 6px;
    cursor: pointer;
    -webkit-appearance: none;
  }
  input[type="range"].slider:focus::-webkit-slider-runnable-track {
    background: ${({ theme }) => theme.colors.black};
  }
  input[type="range"].slider::-moz-range-track {
    background: rgba(0, 0, 0, 0.12);
    border: 0;
    width: 100%;
    height: 0px;
    cursor: pointer;
  }
  input[type="range"].slider::-moz-range-thumb {
    min-width: 6px;
    ${({ width }) => `width: ${width}%;`}
    height: 6px;
    background: ${({ theme }) => theme.colors.black};
    border: 0;
    border-radius: 6px;
    cursor: pointer;
  }
  input[type="range"].slider::-ms-track {
    background: transparent;
    border-color: transparent;
    border-width: 3px 0;
    color: transparent;
    width: 100%;
    height: 0px;
    cursor: pointer;
  }
  input[type="range"].slider::-ms-fill-lower {
    background: ${({ theme }) => theme.colors.black};
    border: 0;
  }
  input[type="range"].slider::-ms-fill-upper {
    background: rgba(0, 0, 0, 0.12);
    border: 0;
  }
  input[type="range"].slider::-ms-thumb {
    min-width: 6px;
    ${({ width }) => `width: ${width}%;`}
    height: 6px;
    background: ${({ theme }) => theme.colors.black};
    border: 0;
    border-radius: 6px;
    cursor: pointer;
    margin-top: 0px;
    /*Needed to keep the Edge thumb centred*/
  }
  input[type="range"].slider:focus::-ms-fill-lower {
    background: rgba(0, 0, 0, 0.12);
  }
  input[type="range"].slider:focus::-ms-fill-upper {
    background: ${({ theme }) => theme.colors.black};
  }
  /*TODO: Use one of the selectors from https://stackoverflow.com/a/20541859/7077589 and figure out
how to remove the virtical space around the range input in IE*/
  @supports (-ms-ime-align: auto) {
    /* Pre-Chromium Edge only styles, selector taken from hhttps://stackoverflow.com/a/32202953/7077589 */
    input[type="range"].slider {
      margin: 0;
      /*Edge starts the margin from the thumb, not the track as other browsers do*/
    }
  }
`;
export const IndicatorContainer = styled.div `
  all: unset;
  position: relative;
  width: 10rem;
  height: 0.5rem;
  border-radius: 6px;
  display: flex;
  align-items: center;
  ${({ theme, dark }) => `background-color: ${dark ? `rgba(${theme.colors.transparentWhite}, 0.36);` : `rgba(${theme.colors.transparentBlack}, 0.12);`}`}
`;
